// Contests list.
// To add a new contest, append an object to this array. Fields:
//   title - contest name / achievement (string, required)
//   year  - year label shown in brackets, e.g. "[2024]"
// Array order = display order.

export const contestsData = [
  {
    title: "ICPC Asia Dhaka Regional Contest 2024",
    year: "[2024]",
  },
  {
    title: "Ranked 6th at DIU DataThon Contest 2024",
    year: "[2024]",
  },
  {
    title: "DIU Unlock The Algorithm Programming contest",
    year: "[2023]",
  },
  {
    title: "DIU Spring TAKEOFF Programming contest",
    year: "[2023]",
  },
  {
    title:
      "Regularly Attend Online CP Contest on Codeforces, Codechef, Atcoder",
    year: "[2023]",
  },
  {
    title: "DIU FALL TAKEOFF Programming contest",
    year: "[2022]",
  },
];
